<app-template-text
  (onblur)="onblur.emit()"
  [disabled]="disabled"
  [characters]="characters"
  [value]="value"
  [control]="control"
  [minlength]="minlength"
  [maxlength]="maxlength"
  [label]="label"
/>
